module.exports = __webpack_public_path__ + "static/media/skin_test_SDK@2x.409f61c9.png";